import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, select, takeLatest } from "redux-saga/effects"
import { formatDateToWeek } from "utils/formatDateToWeek"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import * as notificationActions from "../notifications/notifications.actions"
import * as planningParamsSelectors from "../planningParams/planningParams.selectors"
import * as templatesTableSelectors from "../templateTable/templateTable.selectors"
import * as weekActions from "../weeks/weeks.actions"
import * as actions from "./planningImport.actions"

export function* postTemplateImport(): SagaIterator {
  try {
    const { from } = yield select(planningParamsSelectors.getPlanningParams)
    const week = formatDateToWeek(from)
    const [{ id, name, color }] = yield select(templatesTableSelectors.getSelectedRows)
    const templateImportData = {
      template: { id, name, color },
      week,
    }
    const {
      data: { fail },
    } = yield call(api.importTemplate, { data: templateImportData })
    yield put(actions.postTemplateImportSuccess())
    yield put(weekActions.getWeeks(week))
    yield put(
      notificationActions.show({
        id: "postTemplateImport",
        message: "confirmationdialog.planning.templates.import.message",
        values: { length: fail.length, name, week },
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postTemplateImportFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* planningTimeslotsSaga(): SagaIterator {
  yield takeLatest(actions.Types.POST, postTemplateImport)
}
